import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconUpload = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M16.058 1.928c-1.541.137-3.353.821-4.602 1.74-2.008 1.477-3.32 3.548-3.818 6.03-.11.542-.117 1.486-.136 17.15-.015 12 0 16.776.051 17.3.04.398.14 1.003.224 1.344.827 3.398 3.504 6.107 6.87 6.952 1.122.282 1.445.3 5.097.28l3.456-.02.288-.15c.726-.376 1.116-1.005 1.116-1.802s-.39-1.426-1.116-1.803L23.2 48.8l-3.488-.04c-3.479-.041-3.739-.058-4.448-.29-1.88-.612-3.386-2.367-3.68-4.289-.046-.298-.062-5.74-.05-17.141l.018-16.704.148-.478c.495-1.6 1.71-2.944 3.237-3.579.992-.413.03-.391 17.063-.391s16.07-.022 17.063.391c1.526.635 2.741 1.98 3.237 3.579l.148.478.017 16.704c.012 11.402-.003 16.843-.049 17.141-.294 1.922-1.8 3.677-3.68 4.29-.71.23-.97.248-4.448.288L40.8 48.8l-.288.15c-.726.376-1.112 1.001-1.113 1.802-.001.81.406 1.452 1.145 1.802l.384.182h3.444c3.591 0 3.877-.017 4.98-.292 3.36-.84 6.044-3.555 6.87-6.952.084-.341.184-.946.224-1.344.053-.524.067-5.3.052-17.3-.023-18.517.019-16.89-.471-18.39-1.192-3.648-4.395-6.2-8.198-6.534-.927-.082-30.85-.078-31.771.004m15.207 18.84c-.358.148-.752.527-6.258 6.03-6.578 6.576-6.223 6.172-6.223 7.09 0 .406.03.574.148.812.357.724 1.052 1.163 1.835 1.158.854-.006.65.166 5.123-4.308 2.216-2.216 4.051-4.03 4.077-4.03s.055 7.466.064 16.592l.017 16.592.147.275c.226.424.565.76.962.954.478.234 1.155.245 1.65.027.38-.168.784-.56.995-.968l.15-.288.016-16.592c.01-9.126.038-16.592.064-16.592s1.834 1.788 4.016 3.972 4.083 4.04 4.224 4.123c1.045.617 2.491.052 2.882-1.126a2.1 2.1 0 0 0-.116-1.497c-.126-.244-1.571-1.723-6.074-6.217-5.639-5.628-5.925-5.903-6.279-6.032a1.86 1.86 0 0 0-1.42.025" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconUpload.displayName = 'IconUpload';